(function () {
  'use strict';
  /* "Shop by device" in the header menu: opens the device selector drawer, then shows that phone's cases */
  var LINK = '/collections/all-phone-cases';
  var pending = false;
  function openPicker(e) {
    e.preventDefault();
    var drawer = document.getElementById('mobile-menu-drawer');
    if (drawer && drawer.hasAttribute('open')) { try { drawer.open = false; } catch (x) { drawer.removeAttribute('open'); } }
    if (!window.BSKModel) { window.location.href = LINK; return; }
    pending = true;
    setTimeout(function () { window.BSKModel.open('full'); }, drawer ? 120 : 0);
  }
  document.addEventListener('bsk:model-change', function () {
    if (!pending) return;
    pending = false;
    if (location.pathname.indexOf(LINK) !== 0) window.location.href = LINK;
  });
  document.addEventListener('click', function (e) {
    if (e.target.closest && (e.target.closest('[data-bsk-picker-close]') || e.target.closest('[data-bsk-close]'))) pending = false;
  });
  function add() {
    document.querySelectorAll('.header__linklist').forEach(function (ul) {
      if (ul.querySelector('[data-bsk-shop-device]')) return;
      var li = document.createElement('li');
      li.className = 'header__linklist-item';
      li.innerHTML = '<a href="' + LINK + '" class="header__linklist-link link--animated" data-bsk-shop-device>Shop by device</a>';
      ul.insertBefore(li, ul.firstChild);
    });
    document.querySelectorAll('.mobile-nav').forEach(function (ul) {
      if (ul.querySelector('[data-bsk-shop-device]') || ul.closest('.mobile-nav__item')) return;
      var li = document.createElement('li');
      li.className = 'mobile-nav__item';
      li.innerHTML = '<a href="' + LINK + '" class="mobile-nav__link heading h6" data-bsk-shop-device>Shop by device</a>';
      ul.insertBefore(li, ul.firstChild);
    });
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-bsk-shop-device]');
    if (a) openPicker(e);
  }, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', add); else add();
  var q = false;
  new MutationObserver(function () { if (q) return; q = true; requestAnimationFrame(function () { q = false; add(); }); }).observe(document.documentElement, { childList: true, subtree: true });
})();
